import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ApplicationRouterService } from '../@core/application-router/application-router.service';
import { RouteExecutor } from '../@core/application-router/route.executor';
import { Clickable } from '../@shared/models/clickable.model';
import { FunctionModel } from '../@shared/models/function.model';
import { ErrorWrapper } from '../@shared/models/response-wrapper.model';
import { fPV2Data, fPV2DataFeed } from './footer-v2.data';
import { FooterV2Service } from './footer-v2.service';

@Component({
    selector: 'app-footer-v2',
    templateUrl: './footer-v2.component.html',
    styleUrls: ['./footer-v2.component.scss'],
})
export class FooterV2Component extends RouteExecutor implements OnInit {
    loading = true;
    data: fPV2DataFeed | null | undefined = null;
    errors: ErrorWrapper[] = [];
    @Input() filter: { [p: string]: string | string[] } = {};
    @Input() page = '';
    breadcrumbs: Array<Clickable> = [];
    email = new FormControl('');
    listinglength: number = 0;
    staticLength: number = 0;
    parameters: { [p: string]: string | string[] } = {};
    subscribeMessage = '';
    subscribeColor = '';
    openAccordionIndex: number = (this.listinglength + this.staticLength) * -1;
    // openAccordionIndex: number = -4;
    isBot: boolean = true;

    constructor(
        applicationRouterService: ApplicationRouterService,
        private footerv2service: FooterV2Service
    ) {
        super(applicationRouterService);
        this.footerv2service.breadcrumb.subscribe((res: any) => {
            this.breadcrumbs = res;
        });
        this.isBot = this.detectBotUser();
    }

    ngOnInit(): void {
        this.email.valueChanges.subscribe(() => {
            this.subscribeMessage = '';
            this.subscribeColor = '';
        });
    }
    ngOnChanges() {
        this.footerv2service
            .updateFooter({ ...this.filter, page: this.page })
            .subscribe(res1 => {
                this.loading = false;
                if (res1?.success) {
                    this.data = res1?.data;
                    this.data?.feed
                        .filter(
                            feed =>
                                feed?.layoutType ===
                                    'footer-static-pages-section' ||
                                feed?.layoutType === 'footer-static-pages'
                        )
                        .forEach(n => {
                            this.staticLength = 1;
                        });
                    this.data?.feed
                        .filter(
                            feed => feed?.layoutType === 'footer-listing-fold'
                        )
                        .forEach(n => {
                            const len = n.layoutContent.listing;
                            this.listinglength = len.length;
                        });
                } else {
                    this.data = null;
                }
            });
    }
    externalLinksRedirect(link: string) {
        console.log(link);
        window.open(link, '_blank');
    }
    executeFunctionLink(id: string, query: { [p: string]: string | string[] }) {
        this.applicationRouterService
            .executeFunctionLink(id, query, {
                email: this.email.value,
            })
            .subscribe(
                res => {
                    this.updateState(res.data);
                    res?.data?.redirects?.forEach((link: string) => {
                        this.processLink(link);
                    });
                },
                error => {},
                () => {}
            );
    }

    executePageLink(id: string, query: { [p: string]: string | string[] }) {
        if (query.action === 'footer-filter') {
            delete query.action;
            this.parameters = { page: id.replace('/', ''), ...query };
            //   this.updateFooterPageData();
        } else {
            super.executePageLink(id, query);
        }
    }
    updateState(response: FunctionModel) {
        if (!response) {
            return;
        }
        if (response.updateId === 'newsLetter') {
            this.subscribeMessage = response?.state?.message.text;
            this.subscribeColor = response?.state?.message.color;
        }
    }
    setAccordionState(index: number) {
        this.openAccordionIndex = index;
    }
    checkValidEmail() {
        const pattern =
            /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
        if (!pattern.test(this.email.value!.toString())) {
            this.email.setErrors({ error: 'Invalid Email' });
        } else {
            this.email.setErrors(null);
        }
    }

    onSubscribe(link: string) {
        this.checkValidEmail();

        if (this.email.invalid) {
            this.subscribeMessage = 'Please enter a valid email address';
            return;
        }
        this.processLink(link);
    }

    detectBotUser(): boolean {
        const userAgent = navigator.userAgent.toLowerCase();
        return /bot|crawler|spider|crawling/.test(userAgent);
    }
}
